import styled from 'styled-components';

export const ScTermsBackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100%;
`;

export const ScTermsBlock = styled.div`
  width: 100%;
  max-width: 400px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  // Fades the last bit of text to signal there's more to scroll; cleared
  // once scrolled to the bottom (toggled via the data-at-bottom attribute).
  -webkit-mask-image: linear-gradient(
    to bottom,
    #000 75%,
    #737373 80%,
    transparent 100%
  );
  mask-image: linear-gradient(
    to bottom,
    #000 75%,
    #737373 80%,
    transparent 100%
  );

  &[data-at-bottom='true'] {
    -webkit-mask-image: none;
    mask-image: none;
  }

  // TermsAndConditionsList sets its own li margin-bottom (16px, skipping
  // the last item) with no prop to override it, so it's forced here.
  li {
    margin-bottom: 4px !important;
  }
`;
export const ScTermsTitle = styled.p`
  margin: 0;
  font-family: inherit;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.whiteColor};
  margin-bottom: -12px;

`;

export const ScTermsBackButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.whiteColor};
`;
